import { ReactNode, ComponentPropsWithoutRef } from "react";
import CSS from 'csstype';

import "./style.less";

interface IExternalLink extends ComponentPropsWithoutRef<"a"> {
	to: string;
	children: ReactNode,
	className?: string;
	props?: ComponentPropsWithoutRef<"a">;
	sx?: CSS.Properties;
}

export default function ExternalLink({
	to = "",
	sx = {},
	children = null,
	...props
}: IExternalLink) {
	/* eslint-disable react/jsx-no-target-blank */
	return <a href={to} target="_blank" className="externalLink" style={sx} rel="noopener noreferrer" {...props}>{ children }</a>;
}
